import React from 'react';
import HorizontalBarChart from '../../../shared/horizontalBarChart';
import { Box, Skeleton, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { HORIZONTAL_BAR_CHART_BASE } from './constants';
import useChartOptions from '../../../../utility/hooks/useChartOptions';
import _ from 'lodash';


const DtcTopCityChart = () => {
    const {
        triggerSummary: { isTriggerSummaryGraphsLoading },
        dtcData
    } = useSelector((state) => state.trigger);

    const { isWebMatrixPatientLoading, topCitiesChartData } = dtcData;
    const { series, categories } = topCitiesChartData;

    const { dtcData: engagementRateData } = useSelector(
        (state) => state.webMatrix
    );
    const { isEngagementRateLoading } = engagementRateData;

    const isLoading =
    isWebMatrixPatientLoading ||
    isEngagementRateLoading ||
    isTriggerSummaryGraphsLoading;
    const safeSeries = _.cloneDeep(series);
    const safeCategories = _.cloneDeep(categories);
    const chartOptions = useChartOptions(
        HORIZONTAL_BAR_CHART_BASE,
        { xaxis: { categories: safeCategories || [] } },
        [categories]
    );
    return (
        <Box className="container-p-24-br-16 bg-gray-50">
            <Box>
                <Typography className="text-md-medium gray-900">
          Engagement By Top 10 Cities
                </Typography>
            </Box>
            {isLoading ? (
                <Skeleton height={400} variant="rectangular" width="100%" />
            ) : (
                <HorizontalBarChart chartOptions={chartOptions} chartSeries={safeSeries} key={series}/>
            )}
        </Box>
    );
};

export default DtcTopCityChart;
